<!--
  Верстка адаптирована из шаблона:
  Файл: design-assets/themeforest_4DdWBZd0_education_online_courses_template_istudy (1)/istudy/courses-details.html
  Компонент: "What you'll learn" секция (строки 740-788)
  Стили: design-assets/themeforest_4DdWBZd0_education_online_courses_template_istudy (1)/istudy/assets/css/main.css
  Классы: 
    - .bd-course-details-content-title (строка 18297)
    - .bd-course-details-list-box (строка 18346)
    - .bd-course-details-list (строка 18376)
    - .list-icon.success (строка 18554)
-->
<template>
  <div v-if="props.items.length > 0" class="course-learning">
    <h3 class="learning-title">{{ t('courseDetails.learningObjectives.title') }}</h3>
    <div class="learning-list-box">
      <div class="learning-list">
        <ul>
          <li v-for="(item, index) in leftColumnItems" :key="index">
            <span class="list-icon success" aria-hidden="true">
              <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 5.5L4 8.5L11 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            {{ item }}
          </li>
        </ul>
      </div>
      <div class="learning-list">
        <ul>
          <li v-for="(item, index) in rightColumnItems" :key="index">
            <span class="list-icon success" aria-hidden="true">
              <svg width="12" height="10" viewBox="0 0 12 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M1 5.5L4 8.5L11 1.5" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </span>
            {{ item }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
const { t } = useI18n()
interface Props {
  items: string[]
}

const props = defineProps<Props>()

const leftColumnItems = computed(() => {
  const mid = Math.ceil(props.items.length / 2)
  return props.items.slice(0, mid)
})

const rightColumnItems = computed(() => {
  const mid = Math.ceil(props.items.length / 2)
  return props.items.slice(mid)
})
</script>

<style scoped>
.course-learning {
  margin-bottom: 40px;
}

.learning-title {
  font-family: var(--font-inter);
  font-weight: 600;
  font-size: 26px;
  line-height: 1.3;
  color: #000000;
  margin: 0 0 32px 0;
}

.learning-list-box {
  border-radius: 8px;
  /* padding: 30px; */
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 40px;
}

.learning-list ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.learning-list ul li {
  list-style: none;
  display: flex;
  gap: 10px;
  align-items: flex-start;
  font-family: var(--font-inter);
  font-size: 16px;
  line-height: 1.6;
  color: #252840;
}

.learning-list ul li:not(:last-child) {
  margin-bottom: 15px;
}

.list-icon {
  flex-shrink: 0;
  width: 22px;
  height: 22px;
  min-width: 22px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 4px;
  border-radius: 50%;
  font-size: 12px;
}

.list-icon.success {
  color: #00CE9B;
  background: rgba(0, 206, 155, 0.2);
}

.list-icon.success svg {
  display: block;
}

@media (max-width: 991px) {
  .learning-list-box {
    grid-template-columns: repeat(1, 1fr);
    gap: 30px;
  }

  .learning-list-box::after {
    display: none;
  }
}

@media (max-width: 767px) {
  .learning-list-box {
    padding: 24px 20px;
    gap: 24px;
  }

  .learning-title {
    font-size: 22px;
  }

  .learning-list ul li {
    font-size: 15px;
  }
}

@media (max-width: 575px) {
  .learning-title {
    font-size: 20px;
  }

  .learning-list-box {
    padding: 20px 16px;
  }

  .learning-list ul li {
    font-size: 14px;
  }
}
</style>
